var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrap',[_c('vehicle-manage-panel',{attrs:{"source":"jws","use-jws-api":true,"show-person-code":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }